/**
*Created by jmmartinez on 13/09/21
 * v.1.1 29/10/2024  Añadida la propiedad backgroundColor
 */

import React from 'react'
import PropTypes from 'prop-types';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import 'react-quill/dist/quill.bubble.css';
import 'react-quill/dist/quill.core.css';




class HTMLEditorQuill extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            texto: props.texto
        }
        console.log("CONSTRUCTOR: ", props);
    }


    static getDerivedStateFromProps(nextProps, prevState) {
        const newState = {};

        //Importante!!!!
        //ponemos prevState.texto === "" para que no entre en recursividad.
        if (nextProps.texto !== prevState.texto && prevState.texto === "") {
            newState.texto = nextProps.texto;
        }

        if (Object.keys(newState).length > 0)
            return newState;
        else
            return null;
    }


    changeTexto= (newTexto) => {
        const{onChange} = this.props;
        //console.log("***changeTexto: ", newTexto);
        this.setState({ texto: newTexto }, () => {
            onChange && onChange(newTexto);
        })
    }



    render() {
        const {texto} = this.state;
        const {height, backgroundColor} = this.props;
        //console.log("Texto: ", texto);



        let toolbarOptions = [
            ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
            ['blockquote', 'code-block'],

            [{ 'header': 1 }, { 'header': 2 }],               // custom button values
            [{ 'list': 'ordered'}, { 'list': 'bullet' }],
            [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
            [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
            [{ 'direction': 'rtl' }],                         // text direction

            [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
            //[{ 'header': [1, 2, 3, 4, 5, 6, false] }],

            [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
            //[{ 'font': [] }],
            //[{ 'align': [] }],
            //['link', 'image'],
            ['clean']                                         // remove formatting button
        ];

        let heightDIV= height + "px";
        let heightHTMLEditor= (height - 50) + "px";

        const formats = [
            'bold', 'italic', 'underline', 'strike', // <- estos dos son los que te fallaban
            'blockquote', 'code-block',
            'header', 'list', 'bullet',
            'script', 'indent', 'direction', 'size',
            'color', 'background', 'font', 'align',
            'link', 'image',
            "table", "row","column",// Agregas soporte para tablas
        ];

        return (
            <div style={{height: heightDIV, backgroundColor: backgroundColor}}>
                <ReactQuill value={texto}
                            //defaultValue={texto}
                            onChange={this.changeTexto}
                            modules={{toolbar: toolbarOptions}}
                            style={{height: heightHTMLEditor}}
                            formats={formats}
                />
            </div>
        )
    }

}


HTMLEditorQuill.propTypes = {
    texto: PropTypes.string,
    onChange: PropTypes.func,
    height: PropTypes.number,
    backgroundColor: PropTypes.string,
}

export default HTMLEditorQuill;